"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * User Notification Service
 * User notification api documentation
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationLogDtoToJSON = exports.NotificationLogDtoFromJSONTyped = exports.NotificationLogDtoFromJSON = exports.NotificationLogDtoEmailTypeEnum = exports.NotificationLogDtoTypeEnum = void 0;
const runtime_1 = require("../runtime");
const NotificationLogRoleDto_1 = require("./NotificationLogRoleDto");
/**
* @export
* @enum {string}
*/
var NotificationLogDtoTypeEnum;
(function (NotificationLogDtoTypeEnum) {
    NotificationLogDtoTypeEnum["Reachout"] = "Reachout";
    NotificationLogDtoTypeEnum["Targeted"] = "Targeted";
})(NotificationLogDtoTypeEnum = exports.NotificationLogDtoTypeEnum || (exports.NotificationLogDtoTypeEnum = {})); /**
* @export
* @enum {string}
*/
var NotificationLogDtoEmailTypeEnum;
(function (NotificationLogDtoEmailTypeEnum) {
    NotificationLogDtoEmailTypeEnum["CustomTemplated"] = "CustomTemplated";
    NotificationLogDtoEmailTypeEnum["CustomPlain"] = "CustomPlain";
    NotificationLogDtoEmailTypeEnum["ReachoutTemplated"] = "ReachoutTemplated";
    NotificationLogDtoEmailTypeEnum["ReachoutPlain"] = "ReachoutPlain";
    NotificationLogDtoEmailTypeEnum["ReachoutTemplatedV2"] = "ReachoutTemplatedV2";
})(NotificationLogDtoEmailTypeEnum = exports.NotificationLogDtoEmailTypeEnum || (exports.NotificationLogDtoEmailTypeEnum = {}));
function NotificationLogDtoFromJSON(json) {
    return NotificationLogDtoFromJSONTyped(json, false);
}
exports.NotificationLogDtoFromJSON = NotificationLogDtoFromJSON;
function NotificationLogDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdAt': !(0, runtime_1.exists)(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'createdBy': !(0, runtime_1.exists)(json, 'createdBy') ? undefined : json['createdBy'],
        'roles': (json['roles'].map(NotificationLogRoleDto_1.NotificationLogRoleDtoFromJSON)),
        'type': json['type'],
        'notificationId': !(0, runtime_1.exists)(json, 'notificationId') ? undefined : json['notificationId'],
        'emailType': !(0, runtime_1.exists)(json, 'emailType') ? undefined : json['emailType'],
    };
}
exports.NotificationLogDtoFromJSONTyped = NotificationLogDtoFromJSONTyped;
function NotificationLogDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'createdBy': value.createdBy,
        'roles': (value.roles.map(NotificationLogRoleDto_1.NotificationLogRoleDtoToJSON)),
        'type': value.type,
        'notificationId': value.notificationId,
        'emailType': value.emailType,
    };
}
exports.NotificationLogDtoToJSON = NotificationLogDtoToJSON;
